import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { initReactI18next } from 'react-i18next';

import { configureErrorHandler } from './apocalypse-handler';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import useFirebaseStore from './store/useFirebase';
import useLangStore from './store/useLang';
import usePWAStore from './store/usePWA';
import { messages } from './translate/languages';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    defaultNS: 'translations',
    fallbackLng: useLangStore.getState().lang,
    ns: ['translations'],
    resources: messages,
  });

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);

useFirebaseStore.getState().initializeFirebase();

serviceWorkerRegistration.register({
  onSuccess: worker => {
    usePWAStore.getState().onWorkerSuccess(worker);
    useFirebaseStore.getState().setServiceWorker(worker);
  },
  onUpdate(worker) {
    usePWAStore.getState().onWorkerUpdate(worker);
    useFirebaseStore.getState().setServiceWorker(worker);
  },
});

configureErrorHandler();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
